module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-roll/122assets/fonts/1247229c1fbc30482f89ce0992d25f61.woff";


//////////////////
// WEBPACK FOOTER
// ./app/styles/fonts/icomoon.woff?qmfery
// module id = 1242
// module chunks = 3